export default "__VITE_ASSET__B2ftCgP0__"